// src/pages/Admin/UserAdmin/UserAdminHome.tsx
import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaBroom, FaHistory, FaIdBadge, FaUserCog, FaUsers } from 'react-icons/fa';
import { useRoleAccess } from '@/contexts/RoleAccessContext';
import '../AdminHome.scss';

interface UserAdminTile {
  title: string;
  description: string;
  to: string;
  icon: React.ReactNode;
}

const tiles: UserAdminTile[] = [
  {
    title: 'SharePoint Account Purge',
    description: 'Remove a user\'s SharePoint access and optionally their OneDrive to resolve account collisions.',
    to: '/admin/users/sp-account-purge',
    icon: <FaBroom />,
  },
  {
    title: 'Entra Users',
    description: 'Search and filter the full user dump from Entra.',
    to: '/admin/users/entra-users',
    icon: <FaUsers />,
  },
  {
    title: 'Employee Hierarchy',
    description: 'Search and filter the Workday employee hierarchy extract.',
    to: '/admin/users/employee-hierarchy',
    icon: <FaIdBadge />,
  },
  {
    title: 'Employee Change History',
    description: 'Look up Workday change history for an employee, including terminations.',
    to: '/admin/users/employee-hierarchy-changes',
    icon: <FaHistory />,
  },
];

const UserAdminHome: React.FC = () => {
  const { loading } = useRoleAccess();

  if (loading) {
    return <Container className="mt-4 admin-home"><p>Loading permissions...</p></Container>;
  }

  return (
    <Container className="mt-4 admin-home">
      <div className="mb-4">
        <div className="d-flex align-items-center gap-2 mb-1">
          <FaUserCog className="text-muted" />
          <h2 className="mb-0">User Admin</h2>
        </div>
        <p className="text-muted">Manage user access and account operations.</p>
      </div>

      <Row className="g-3">
        {tiles.map((tile) => (
          <Col key={tile.to} xs={6} sm={4} md={3}>
            <Card
              as={Link}
              to={tile.to}
              className="admin-home-tile h-100 text-decoration-none"
            >
              <Card.Body className="d-flex flex-column align-items-center justify-content-center text-center p-3 gap-2">
                <div className="admin-home-tile-icon">{tile.icon}</div>
                <div className="fw-semibold">{tile.title}</div>
                <div className="admin-home-tile-desc small">{tile.description}</div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default UserAdminHome;
